export default "__VITE_ASSET__t_oJ5X6S__"